import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_collective_bargaining_agreements_cbas_have_there_been'

export const dataPointDefinition = {
  retracedId: 'how_many_collective_bargaining_agreements_cbas_have_there_been',
  name: 'How many Collective Bargaining Agreements (CBAs) have there been in effect at the facility during the assessment timeframe? ',
  description:
    "Collective Bargaining Agreements: Written agreements regarding working conditions and terms of employment concluded between an employer and representative workers' organization(s).\r\r\n\r\r\nInclude all CBAs that have applied to workers in the facility (enterprise level, sectoral level, national level, etc.) during the assessment timeframe, even if the CBA has expired in the assessment timeframe. ",
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12330,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
